export default __webpack_public_path__ + "static/google_logo-7e9e276c8f7ddf0b416a546527ef8c04.svg";